import {useEffect} from 'react';
import {KEYSTROKE_ENTER} from '@/constants';

export function useFormSubmit(submitFn: () => void, args?: any[]) {
  useEffect(() => {
    const handleEnterKey = (e: KeyboardEvent) => {
      if (e.key === KEYSTROKE_ENTER) {
        submitFn();
      }
    };
    window.addEventListener('keydown', handleEnterKey);
    return () => window.removeEventListener('keydown', handleEnterKey);
  }, [submitFn, ...(args ?? [])]);
}
